import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProgressSpinnerModule } from '@openng/optimus-ui/progressspinner';

@Component({
  selector: 'core-progress',
  imports: [ProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="my-20 flex w-full flex-col items-center">
      <p-progress-spinner data-testid="spinner" />
    </div>
  `,
})
export class ProgressComponent {}
